import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DOMAIN_ENVIRONMENT } from 'src/app/_services/base.service';
import { PlatformService } from 'src/app/_services/platform.service';
import { UtilsService } from 'src/app/_services/utils.service';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { FichaCarteraComponent } from 'src/app/funds/shared/home/ficha-cartera/ficha-cartera.component';
import { FichaProductosFunds } from 'src/app/home/_models/ficha-productos-funds';
import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';


@Component({
  selector: 'app-home-funds',
  templateUrl: './home-funds.component.html',
  styleUrls: ['./home-funds.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    RouterModule,
    FichaCarteraComponent,
  ]
})

export class HomeFundsComponent implements OnInit
{
  isPlatformFunds: boolean = false;
  domainUrl: string;
  isLoading: boolean = false;
  criptoCardDataList: FichaProductosFunds[];
  swiperHomeFunds: Swiper;
  contenedorMargen: number;


  constructor(
    @Inject(PLATFORM_ID) private _platformId: Object,
    private _utilService: UtilsService,
    private _platformService: PlatformService
  ) { }

  ngOnInit(): void
  {
    this.getContainerMargins();
    if (isPlatformBrowser(this._platformId))
    {
      this.buildSwiperCarteras();
    }
    this.isPlatformFunds = DOMAIN_ENVIRONMENT[this._platformService._domainEnvironment] == 'FUNDS' ? true : false;
    this.domainUrl = this._platformService.getSubdominioUrl('funds');
    this.getCardData();
  }

  private getContainerMargins(): void
  {
    this.contenedorMargen = this._utilService.getContainerMargins("contenedor-margen");
  }

  private getCardData(): void
  {
    this.criptoCardDataList = [
      {
        id: 1,
        imgSrc: 'assets/images/funds/criptos/bitcoin-card.jpg',
        title: 'Invierte en el líder de las criptomonedas.',
        subtitle: 'Accede al potencial de Bitcoin con la seguridad de un ETF regulado.'
      },
      {
        id: 2,
        imgSrc: 'assets/images/funds/criptos/ethereum-card.jpg',
        title: 'Invierte en la revolución Ethereum.',
        subtitle: 'Participa en el crecimiento de la red blockchain líder en innovación.'
      },
      {
        id: 3,
        imgSrc: 'assets/images/funds/criptos/etfs-card.jpg',
        title: 'Bitcoin y Ethereum, juntos en tu cartera.',
        subtitle: 'Accede a dos de los mayores activos digitales con un solo producto.'
      }
    ]
  }

  private buildSwiperCarteras(): void
  {
    this.swiperHomeFunds = new Swiper('.swiperHomeFunds', {

      modules: [Pagination],
      spaceBetween: 20,
      slidesPerView: 1.2,
      slidesOffsetAfter: this.contenedorMargen,
      slidesOffsetBefore: this.contenedorMargen,
      breakpoints: {
        576.98: {
          slidesPerView: 1.3,
          spaceBetween: 20,
        },
        678.98: {
          slidesPerView: 1.7,
          spaceBetween: 20,
        },
        767.98: {
          slidesPerView: 2.3,
          spaceBetween: 20
        },
        805.98: {
          slidesPerView: 2.5,
          spaceBetween: 20
        },
        877.98: {
          slidesPerView: 2.7,
          spaceBetween: 20
        },
        991.98: {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0
        }
      },
      pagination: {
        el: '.swiper-home-funds',
        clickable: true
      },
      on: {
        init: () =>
        {
          if (window.innerWidth > 991.98)
          {
            const contenedorSwiper = document.getElementById('contenedor-swiper-home-funds');
            contenedorSwiper.style.marginLeft = this.contenedorMargen + 'px';
            contenedorSwiper.style.marginRight = this.contenedorMargen + 'px';
          }
        }
      }
    })
  }

}
